import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    forgotPassword,
    returnToLogin,
    sendVerificationCode,
    updateEmail,
    verificationCodeReceived,
    login
} from './loginActions';
import {
    getEmail,
    getLoginView,
    getReadmeToken,
    getIsReadmeTokenLoading,
    getReadmeTokenError,
    getReadmeTokenErrorMessage
} from './loginViewState';
import {
    getIsLoginLoading,
    getIsVerificationLoading,
    getLoginError,
    getLoginErrorMessage,
    getSendVerificationCodeErrorMessage
} from '../UserData/userDataEntity';
import ReadmeForm from './LoginForm/ReadmeLoginForm';
import ForgotPassword from './ForgotPassword/ForgotPassword';
import ConfirmVerificationCodeReceived from './ConfirmVerificationCodeReceived/ConfirmVerificationCodeReceived';
import { historyShape } from '../../utils/propTypes';
import { toastIfError } from '../../utils/toast';
import { getWasAccountCreatedSuccessfully } from '../Signup/signupEntity';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import './Login.scss';

export class ReadmeLogin extends Component {
    static propTypes = {
        email: PropTypes.string,
        error: PropTypes.shape({
            message: PropTypes.string.isRequired
        }),
        readmeError: PropTypes.shape({
            message: PropTypes.string.isRequired
        }),
        errorMessage: PropTypes.string,
        readmeTokenErrorMessage: PropTypes.string,
        history: historyShape,
        isLoginLoading: PropTypes.bool,
        isReadmeTokenLoading: PropTypes.bool,
        isVerificationLoading: PropTypes.bool,
        loginView: PropTypes.string,
        onForgotPassword: PropTypes.func,
        onReadmeLogin: PropTypes.func,
        onReturnToLogin: PropTypes.func,
        onLogin: PropTypes.func,
        onSendVerificationCode: PropTypes.func,
        onUpdateEmail: PropTypes.func,
        onVerificationCodeReceived: PropTypes.func,
        sendVerificationCodeErrorMessage: PropTypes.string,
        verificationCode: PropTypes.string,
        wasAccountCreatedSuccessfully: PropTypes.bool,
        readmeToken: PropTypes.string
    };

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'errorMessage');
        toastIfError(prevProps, this.props, 'sendVerificationCodeErrorMessage');
        toastIfError(prevProps, this.props, 'readmeErrorMessage');
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'readmeToken')) {
            window.location.replace(`https://docs.nexiopay.com?auth_token=${this.props.readmeToken}`);
        }
    }

    renderView() {
        switch (this.props.loginView) {
            case 'forgotPassword':
                return (
                    <ForgotPassword
                        email={this.props.email}
                        isLoading={this.props.isVerificationLoading}
                        onReturnToLogin={this.props.onReturnToLogin}
                        onUpdateEmail={this.props.onUpdateEmail}
                        onSendVerificationCode={this.props.onSendVerificationCode}
                    />
                );

            case 'confirmVerificationCodeReceived':
                return (
                    <ConfirmVerificationCodeReceived
                        email={this.props.email}
                        onReturnToLogin={this.props.onReturnToLogin}
                        onVerificationCodeReceived={this.props.onVerificationCodeReceived}
                    />
                );

            default:
                return (
                    <ReadmeForm
                        email={this.props.email}
                        isLoading={this.props.isLoginLoading || this.props.isReadmeTokenLoading}
                        onLogin={this.props.onLogin(this.props.history)}
                        onUpdateEmail={this.props.onUpdateEmail}
                        onForgotPassword={this.props.onForgotPassword}
                        wasAccountCreatedSuccessfully={this.props.wasAccountCreatedSuccessfully}
                    />
                );
        }
    }

    render() {

        return (
            <div className="emvio-login">
                <div className="login-container">
                    <div className="logo" onClick={this.props.onReturnToLogin} />
                    {this.renderView()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        email: getEmail(state),
        error: getLoginError(state),
        errorMessage: getLoginErrorMessage(state),
        readmeErrorMessage: getReadmeTokenErrorMessage(state),
        readmeTokenError: getReadmeTokenError(state),
        isLoginLoading: getIsLoginLoading(state),
        isVerificationLoading: getIsVerificationLoading(state),
        readmeToken: getReadmeToken(state),
        loginView: getLoginView(state),
        sendVerificationCodeErrorMessage: getSendVerificationCodeErrorMessage(state),
        wasAccountCreatedSuccessfully: getWasAccountCreatedSuccessfully(state),
        isReadmeTokenLoading: getIsReadmeTokenLoading(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onForgotPassword: (e) => {
            e.preventDefault();
            dispatch(forgotPassword());
        },
        onLogin: (history) => (userName, password) => (e) => {
            e.preventDefault();
            login(userName, password, dispatch, history, true);
        },
        onReturnToLogin: (e) => {
            e.preventDefault();
            dispatch(returnToLogin());
        },
        onSendVerificationCode: (email) =>
            (e) => {
                e.preventDefault();
                sendVerificationCode(email, dispatch);
            },
        onUpdateEmail: (e) => dispatch(updateEmail(e.target.value)),
        onVerificationCodeReceived: () => dispatch(verificationCodeReceived())
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReadmeLogin));
